<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the checkbox group"
      [formField]="configForm.helpText" />
    <div class="flex flex-col gap-3">
      <label class="text-sm font-medium text-slate-700">
        Options
      </label>
      @for (option of model().options; track $index) {
        <div class="flex items-center gap-2">
          <lib-signal-text-field
            [formField]="configForm.options[$index]"
            placeholder="Enter option" />
          <lib-signal-button
            type="button"
            [appearance]="'outline'"
            size="sm"
            (click)="removeOption($index)">X Remove Option
          </lib-signal-button>
        </div>
      }
      <lib-signal-button
        type="button"
        [appearance]="'outline'"
        size="sm"
        (click)="addOption()">+ Add Option
      </lib-signal-button>
    </div>
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must select at least one option"
      [formField]="configForm.required" />
  </section>
</form>
